import { useEffect } from 'react';

export default function Settings() {
  useEffect(() => {
    document.title = 'The Base | Settings & Privacy';
  }, []);
  return <div>Settings</div>;
}
